import { createContext } from 'react'
import { ModalContextType } from './types/modal-context'

export const ModalContext = createContext<ModalContextType>({ isOpen: false, onClose: () => null })
